import { render, staticRenderFns } from "./IconClone.vue?vue&type=template&id=48b351db&"
import script from "./IconClone.vue?vue&type=script&lang=js&"
export * from "./IconClone.vue?vue&type=script&lang=js&"
import style0 from "./IconClone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports